export enum FormsConnector {
    SourceCode = "forms",
    FormGrids = "formGrids"
}
